import { type PropsWithChildren } from 'react';

import { valueStyle } from './Value.sty.js';
import type { ComponentWithName } from '../../../../../../core/types/component-with-name.js';

export const Value = ({ children }: PropsWithChildren) => {
  if (children === undefined) {
    return null;
  }

  return <p className={valueStyle}>{children}</p>;
};

(Value as ComponentWithName<typeof Value>).displayName = 'MeterBarLayout.Value';
